import React, { useEffect, useContext } from "react";
import { AuthContext } from "../../../shared/services/auth-context/auth-context";
import luxoraLogo from "../../../../assets/luxora.png";


function Logout() {

    const { logout } = useContext(AuthContext);

    useEffect(() => {
        logout();
    }, []);

    return (
        <div>
             <div className="container h-100">
                <div className="row justify-content-sm-center h-100">
                    <div className="col-xxl-4 col-xl-5 col-lg-5 col-md-7 col-sm-9">
                        <div className="text-center my-5">
                            <img src={luxoraLogo} alt="Luxora Logo" className="logo" />
                        </div>

                        <div className="card shadow-lg">
                            <div className="card-body p-5">
                                <h1 className="fs-4 card-title fw-bold mb-4">Logout</h1>
                                <p>You have been logged out successfully!!</p>
                            </div>
                            <div className="card-footer py-3 border-0">
                                <div className="text-center">
                                    <a href="/login" className="text-dark fw-bold">Click here</a> to login
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
}


export default Logout;